(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5629,3264],{

/***/ 36981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68777);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var Button = function Button(_ref) {
  var icondown = _ref.icondown,
      onSubmit = _ref.onSubmit,
      text = _ref.text,
      src = _ref.src,
      img = _ref.img,
      hoverImg = _ref.hoverImg,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      color = _ref.color,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      margin = _ref.margin,
      background = _ref.background,
      borderRadius = _ref.borderRadius,
      border = _ref.border,
      width = _ref.width,
      height = _ref.height,
      hoverBackground = _ref.hoverBackground,
      target = _ref.target,
      borderColor = _ref.borderColor,
      hoverColor = _ref.hoverColor,
      icon = _ref.icon,
      padding = _ref.padding,
      newtablink = _ref.newtablink,
      iconvideo = _ref.iconvideo;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledBtn, {
    className: "dc-btn fade-up",
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    background: background,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing,
    margin: margin,
    border: border,
    img: img,
    borderRadius: borderRadius,
    width: width,
    hoverImg: hoverImg,
    hoverBackground: hoverBackground,
    height: height,
    borderColor: borderColor,
    target: target,
    hoverColor: hoverColor,
    onSubmit: onSubmit,
    padding: padding,
    children: // ok
    src ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: src || '/',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
          children: text
        })
      })
    }) : newtablink ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: newtablink || '/',
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
          children: ["  ", icon ? icondown ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "19",
            height: "20",
            viewBox: "0 0 19 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "download",
              transform: "translate(-3.637 -3)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8769",
                "data-name": "Path 8769",
                d: "M4.692,16a1.054,1.054,0,0,1,1.056,1.053v2.105a1.051,1.051,0,0,0,.309.744h0a1.057,1.057,0,0,0,.746.308H19.47a1.054,1.054,0,0,0,1.056-1.053V17.053a1.056,1.056,0,0,1,2.111,0v2.105a3.162,3.162,0,0,1-3.167,3.158H6.8a3.162,3.162,0,0,1-3.167-3.158V17.053A1.054,1.054,0,0,1,4.692,16Z",
                transform: "translate(0 0.684)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8770",
                "data-name": "Path 8770",
                d: "M6.946,10.308a1.058,1.058,0,0,1,1.493,0l4.531,4.519L17.5,10.308A1.054,1.054,0,0,1,18.994,11.8L13.716,17.06a1.058,1.058,0,0,1-1.493,0L6.946,11.8A1.051,1.051,0,0,1,6.946,10.308Z",
                transform: "translate(0.167 0.368)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8771",
                "data-name": "Path 8771",
                d: "M12.692,3a1.054,1.054,0,0,1,1.056,1.053V16.684a1.056,1.056,0,0,1-2.111,0V4.053A1.054,1.054,0,0,1,12.692,3Z",
                transform: "translate(0.444)",
                fill: "#fff",
                fillRule: "evenodd"
              })]
            })
          }) : iconvideo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20.003",
            height: "20",
            viewBox: "0 0 20.003 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "Group_19478",
              "data-name": "Group 19478",
              transform: "translate(-158 -480)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8772",
                "data-name": "Path 8772",
                d: "M19.558,25.667H17a2.318,2.318,0,0,0-4.449,0H1.667a.667.667,0,0,0,0,1.334H12.555A2.318,2.318,0,0,0,17,27h2.554a.667.667,0,0,0,0-1.334ZM14.78,27.333a1,1,0,1,1,1-1A1,1,0,0,1,14.78,27.333Z",
                transform: "translate(157 471.336)"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8773",
                "data-name": "Path 8773",
                d: "M18.909,1H3.094A2.1,2.1,0,0,0,1,3.094V13.575a2.1,2.1,0,0,0,2.094,2.094H18.909A2.1,2.1,0,0,0,21,13.575V3.094A2.1,2.1,0,0,0,18.909,1Zm.76,12.575a.761.761,0,0,1-.76.76H3.094a.761.761,0,0,1-.76-.76V3.094a.761.761,0,0,1,.76-.76H18.909a.761.761,0,0,1,.76.76Z",
                transform: "translate(157 479)"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8774",
                "data-name": "Path 8774",
                d: "M18.354,9.435,13.02,6.1A.667.667,0,0,0,12,6.667v6.668a.667.667,0,0,0,1.02.565l5.334-3.334a.667.667,0,0,0,0-1.133Zm-5.021,2.7V7.867L16.743,10Z",
                transform: "translate(153.334 477.334)"
              })]
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "login_2",
              "data-name": "login 2",
              transform: "translate(-3.25)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8718",
                "data-name": "Path 8718",
                d: "M12.107,3.25a.857.857,0,1,0,0,1.714,8.286,8.286,0,0,1,0,16.571.857.857,0,1,0,0,1.714,10,10,0,0,0,0-20Z",
                transform: "translate(1.143 -3.25)",
                fill: "#fff"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8719",
                "data-name": "Path 8719",
                d: "M11.5,9.713A.857.857,0,1,1,12.713,8.5l3.429,3.429a.857.857,0,0,1,0,1.212L12.713,16.57A.857.857,0,1,1,11.5,15.358l1.965-1.965H4.107a.857.857,0,0,1,0-1.714h9.359Z",
                transform: "translate(0 -2.536)",
                fill: "#fff"
              })]
            })
          }) : '', text]
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: 'javascript:void(0)',
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
          children: ["  ", icon ? icondown ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "19",
            height: "20",
            viewBox: "0 0 19 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "download",
              transform: "translate(-3.637 -3)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8769",
                "data-name": "Path 8769",
                d: "M4.692,16a1.054,1.054,0,0,1,1.056,1.053v2.105a1.051,1.051,0,0,0,.309.744h0a1.057,1.057,0,0,0,.746.308H19.47a1.054,1.054,0,0,0,1.056-1.053V17.053a1.056,1.056,0,0,1,2.111,0v2.105a3.162,3.162,0,0,1-3.167,3.158H6.8a3.162,3.162,0,0,1-3.167-3.158V17.053A1.054,1.054,0,0,1,4.692,16Z",
                transform: "translate(0 0.684)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8770",
                "data-name": "Path 8770",
                d: "M6.946,10.308a1.058,1.058,0,0,1,1.493,0l4.531,4.519L17.5,10.308A1.054,1.054,0,0,1,18.994,11.8L13.716,17.06a1.058,1.058,0,0,1-1.493,0L6.946,11.8A1.051,1.051,0,0,1,6.946,10.308Z",
                transform: "translate(0.167 0.368)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8771",
                "data-name": "Path 8771",
                d: "M12.692,3a1.054,1.054,0,0,1,1.056,1.053V16.684a1.056,1.056,0,0,1-2.111,0V4.053A1.054,1.054,0,0,1,12.692,3Z",
                transform: "translate(0.444)",
                fill: "#fff",
                fillRule: "evenodd"
              })]
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "login_2",
              "data-name": "login 2",
              transform: "translate(-3.25)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8718",
                "data-name": "Path 8718",
                d: "M12.107,3.25a.857.857,0,1,0,0,1.714,8.286,8.286,0,0,1,0,16.571.857.857,0,1,0,0,1.714,10,10,0,0,0,0-20Z",
                transform: "translate(1.143 -3.25)",
                fill: "#fff"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8719",
                "data-name": "Path 8719",
                d: "M11.5,9.713A.857.857,0,1,1,12.713,8.5l3.429,3.429a.857.857,0,0,1,0,1.212L12.713,16.57A.857.857,0,1,1,11.5,15.358l1.965-1.965H4.107a.857.857,0,0,1,0-1.714h9.359Z",
                transform: "translate(0 -2.536)",
                fill: "#fff"
              })]
            })
          }) : '', text]
        })
      })
    })
  });
};

var StyledBtn = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Button__StyledBtn",
  componentId: "sc-1qz5gh2-0"
})(["&.dc-btn{margin:", ";width:", ";height:", "px;cursor:pointer;a{display:flex;width:", ";height:100%;align-items:center;justify-content:center;font-size:", "px;font-weight:", ";margin:0;line-height:", "px;background-color:", ";position:relative;border-radius:", "px;overflow:hidden;z-index:0;transition:border 1s cubic-bezier(.25,.74,.22,.99);padding:", ";box-sizing:border-box;border:", ";border-color:", ";border-style:", ";span{transition:all 1s cubic-bezier(.25,.74,.22,.99);color:", ";position:relative;z-index:2;top:2px;line-height:45px;svg{margin-right:8px;line{transition:all 1s cubic-bezier(.25,.74,.22,.99);}path{transition:all 1s cubic-bezier(.25,.74,.22,.99);}}}&:before{bottom:0;content:\"\";display:block;position:absolute;right:0;top:0;left:0;background-color:", ";height:100%;width:100%;margin:auto;transition:all 1s cubic-bezier(.25,.74,.22,.99);border-radius:22px;transform:translateY(100px);}&:hover{span{color:", ";}svg{line{stroke:", ";}path{fill:", ";}}&:before{transform:translate(0);}}&:focus{color:#222222;}}}"], function (props) {
  return props.margin || '0';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.height || '44';
}, function (props) {
  return props.width || 'fit-content';
}, function (props) {
  return props.fontSize || '16';
}, function (props) {
  return props.fontWeight || 500;
}, function (props) {
  return props.lineHeight || '24';
}, function (props) {
  return props.background || "#978C21";
}, function (props) {
  return props.borderRadius || '22';
}, function (props) {
  return props.padding || "0px 36px";
}, function (props) {
  return props.border || "none";
}, function (props) {
  return props.borderColor || "transparent";
}, function (props) {
  return props.border ? 'solid' : "transparent";
}, function (props) {
  return props.color || "#FFFFFF";
}, function (p) {
  return p.hoverBackground || '#3C3C3B';
}, function (props) {
  return props.hoverColor || "#FFF";
}, function (props) {
  return props.hoverColor || '#FFF';
}, function (props) {
  return props.hoverColor || '#FFF';
});
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Button));

/***/ }),

/***/ 39961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(97346);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25317);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62642);
/* harmony import */ var react_outside_click_handler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39834);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68312);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36981);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93264);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22920);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87536);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _pages_api_network_ApiServices__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92495);
/* harmony import */ var _pages_api_redux_contact__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86221);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);



















var MainMenu = function MainMenu(_ref) {
  var data = _ref.data,
      hovered = _ref.hovered,
      MenuOpen = _ref.MenuOpen,
      ClickShanta = _ref.ClickShanta;
  // variable
  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  var pathname = location.pathname;
  var tl = new gsap__WEBPACK_IMPORTED_MODULE_11__/* .TimelineLite */ .Vq();
  var mobileMenuRaf = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var menuRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var hamburgerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var hamburgerDesktopRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var hamburgerCloseRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var searchClickRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var searchItemRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      activehanta = _useState[0],
      setActivehanta = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      showSubmenu = _useState2[0],
      setShowSubmenu = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(MenuOpen ? MenuOpen : false),
      isMenuOpen = _useState3[0],
      setIsMenuOpen = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(ClickShanta ? ClickShanta : false),
      isHandleClickShanta = _useState4[0],
      setIsHandleClickShanta = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(hovered ? hovered : 'all'),
      hoveredAttr = _useState5[0],
      setHoveredAttr = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      searchInput = _useState6[0],
      setSearchInput = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      windowWidth = _useState7[0],
      setWindowWidth = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('90'),
      offset = _useState8[0],
      setOffset = _useState8[1]; // get offset for container


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (windowWidth > 767) {
      setOffset(document.querySelector('.container').offsetLeft + 15);
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var updateOffset = function updateOffset() {
      if (windowWidth > 767) {
        var container = document.querySelector('.container');

        if (container) {
          setOffset(container.offsetLeft + 15);
        }
      }
    }; // Add an event listener for the DOMContentLoaded event


    document.addEventListener('DOMContentLoaded', updateOffset); // Add event listener to update offset on window resize

    window.addEventListener('resize', updateOffset);
    window.addEventListener('load', updateOffset);
    return function () {
      document.removeEventListener('DOMContentLoaded', updateOffset);
      window.removeEventListener('resize', updateOffset);
      window.removeEventListener('load', updateOffset);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Function to handle window resize
    var handleResize = function handleResize() {
      setWindowWidth(windowWidth);
    }; // Initial window width


    setWindowWidth(windowWidth); // Add event listener for window resize

    window.addEventListener('resize', handleResize); // Cleanup the event listener on component unmount

    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // search handle

  var handleInput = function handleInput(e) {
    setSearchInput(e.target.value);
  };

  var searchSubmit = function searchSubmit(e) {
    e.preventDefault();

    if (searchInput === '') {
      return;
    } else {
      window.location.href = "/search?keyword=".concat(searchInput);
      document.querySelector('.search-desktop').classList.remove('search-open');
      gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(searchItemRef.current, {
        duration: .4,
        height: 0,
        opacity: 0,
        overflow: 'hidden'
      });
      gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(searchItemRef.current.querySelector('.container'), {
        opacity: 0
      }, '-=.4');
      gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(searchItemRef.current, {
        display: 'none'
      });
    } // setSearchInput('')

  }; // remov all menu and search function


  var remove_all = function remove_all(e) {
    var search = document.querySelectorAll(".search-desktop");
    search.forEach(function (i) {
      i.classList.remove("search-open");
    }); // disableBodyScroll(e);
    // clearAllBodyScrollLocks(e)
  };

  var remove_search = function remove_search(e) {
    setSearchInput('');
    document.querySelector('.search-desktop').classList.remove('search-open');
    gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(searchItemRef.current, {
      duration: .4,
      height: 0,
      opacity: 0,
      overflow: 'hidden'
    });
    gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(searchItemRef.current.querySelector('.container'), {
      opacity: 0
    }, '-=.4');
    gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(searchItemRef.current, {
      display: 'none'
    });
    document.querySelector('body').classList.remove('open_menu'); // disableBodyScroll(e);
    // clearAllBodyScrollLocks(e)
    // remove_all();
  };

  var remove_all_mobile = function remove_all_mobile(e) {
    var menuOpen = document.querySelectorAll(".Mobile-menu-wrap");
    var hamburger = document.querySelectorAll(".hamburger");
    var menu = document.querySelectorAll(".main_child");
    var menuSub = document.querySelectorAll(".main-child-sub ");
    var menuSubSub = document.querySelectorAll(".main-child-sub-sub");
    hamburger.forEach(function (i) {
      i.classList.remove("menu-open");
      gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(menuRef.current, {
        opacity: 0,
        duration: ".2"
      });
      gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(menuRef.current, {
        display: "none"
      });
    });
    menuOpen.forEach(function (i) {
      i.classList.remove("menu-open");
    });
    menu.forEach(function (i) {
      i.classList.remove("submenu-open-mb");
    });
    menuSub.forEach(function (i) {
      i.classList.remove("submenu-open-next");
    });
    menuSubSub.forEach(function (i) {
      i.classList.remove("submenu-open-next-next");
      i.classList.remove("submenu-open-next");
      i.classList.remove("submenu-open-mb");
    });
    setHoveredAttr('all');
    var mobile = document.querySelector("#mobile-subscribe");
    mobile.classList.remove('visible');
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var body = document.body;
    var scrollUp = "scroll-up";
    var scrollDown = "scroll-down"; // Mobile menu start
    // for mobile submenu

    var getDropdownChildMobile = document.querySelectorAll(".main_child");
    getDropdownChildMobile.forEach(function (i) {
      i.addEventListener("click", function (r) {
        if (r.target.parentElement.classList.contains('submenu-open-mb')) {
          r.target.parentElement.classList.remove("submenu-open-mb");
        } else {
          r.target.parentElement.classList.toggle("submenu-open-mb");
          document.querySelector('.submenu-open-mb').addEventListener('click', function (ne) {
            var parent = ne.target.parentElement;
            parent.parentElement.classList.remove("submenu-open-mb");
          });
        }
      });
    });
    var nextStepChild = document.querySelectorAll(".main-child-sub");
    nextStepChild.forEach(function (i) {
      i.addEventListener("click", function (r) {
        if (r.target.parentElement.classList.contains('submenu-open-next')) {
          r.target.parentElement.classList.remove("submenu-open-next");
        } else {
          r.target.parentElement.classList.toggle("submenu-open-next");
          document.querySelector('.submenu-open-next').addEventListener('click', function (ne) {
            var parent = ne.target.parentElement;
            parent.parentElement.classList.remove("submenu-open-next");
          });
        }
      });
    });
    var nextStepChildChild = document.querySelectorAll(".main-child-sub-sub");
    nextStepChildChild.forEach(function (i) {
      i.addEventListener("click", function (r) {
        if (r.target.parentElement.classList.contains('submenu-open-next-next')) {
          r.target.parentElement.classList.remove("submenu-open-next-next");
        } else {
          r.target.parentElement.classList.toggle("submenu-open-next-next");
          document.querySelector('.submenu-open-next-next').addEventListener('click', function (ne) {
            var parent = ne.target.parentElement;
            parent.parentElement.classList.remove("submenu-open-next-next");
          });
        }
      });
    }); // menu click on mobile

    hamburgerRef.current.addEventListener("click", function (e) {
      document.querySelector(".hamburger").classList.add("menu-open");
      document.querySelector(".Mobile-menu-wrap").classList.add("menu-open");
      gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(menuRef.current, {
        display: "block"
      });
      gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(menuRef.current, {
        opacity: 1,
        duration: ".3"
      }); // disableBodyScroll(e);
      // clearAllBodyScrollLocks(e)
    });
    hamburgerCloseRef.current.addEventListener("click", function (e) {
      document.querySelector(".hamburger").classList.remove("menu-open");
      document.querySelector(".Mobile-menu-wrap").classList.remove("menu-open");
      gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(menuRef.current, {
        opacity: 0,
        duration: ".2"
      });
      gsap__WEBPACK_IMPORTED_MODULE_12__/* .gsap.to */ .p8.to(menuRef.current, {
        display: "none"
      }); // enableBodyScroll(e);
      // clearAllBodyScrollLocks(e);

      remove_all_mobile(e);
    }); // Mobile menu end
    //---- on scroll menu fixed action

    if (document.body.classList.contains("scroll-up")) {
      document.body.classList.remove("scroll-up");
    } // Clear any active scroll locks

  }, []); // in home page menu & logo click off

  var handleHamburgerClick = function handleHamburgerClick(e) {
    // Add or remove class from the body element
    setIsMenuOpen(function (prevActiveham) {
      return !prevActiveham;
    });
    setIsHandleClickShanta(true); // Set flag to true

    var height = isMenuOpen ? "0" : "auto";
    var opacity = isMenuOpen ? "0" : "1";
    var hidden = isMenuOpen ? "" : "menu-open";
    tl.to(document.querySelector(".desktop-menu__bottom"), {
      height: height,
      duration: 0.6,
      ease: 'Power1.easeOut'
    }, "-=0.3").to(document.querySelector(".mega_menu"), {
      height: height,
      duration: 0.3,
      ease: 'Power1.easeOut'
    }).to('.desktop-menu__bottom .mega_menu .content_wrap li', {
      duration: .5,
      opacity: opacity,
      delay: 0.3,
      stagger: 0.1,
      ease: 'Power1.easeOut'
    }, "0").to('.desktop-menu__bottom .mega_menu .content_wrap .dc-btn', {
      duration: .5,
      opacity: opacity,
      stagger: 0.1,
      ease: 'Power1.easeOut'
    }, "0").to('.desktop-menu__bottom .mega_menu .fixed_menu .content', {
      duration: .5,
      opacity: opacity,
      ease: 'Power1.easeOut'
    }, '-=0.5').to('.desktop-menu__bottom .mega_menu .fixed_menu  .social li', {
      duration: .5,
      opacity: opacity,
      ease: 'Power1.easeOut'
    }).to(document.querySelector('body'), {
      overflow: hidden,
      duration: 0.6,
      ease: 'Power1.easeOut'
    }, '-=0.3');

    if (activehanta) {
      handleclickshanta();
    }

    if (isMenuOpen) {
      setTimeout(function () {
        document.querySelector('body').classList.remove('open_menu'); // enableBodyScroll(e)
      }, 500);
    } else {
      setTimeout(function () {
        document.querySelector('body').classList.add('open_menu'); // disableBodyScroll(e)
        // clearAllBodyScrollLocks(e);
      }, 300);
    }
  };

  var handleclickshanta = function handleclickshanta(e) {
    setActivehanta(function (prevActivehanta) {
      return !prevActivehanta;
    });
    setIsHandleClickShanta(true); // Set flag to true

    var height = activehanta ? "0" : "100%";
    var opacity = activehanta ? "0" : "1";
    var width = activehanta ? "65.5%" : "34.5%";
    var widthm = activehanta ? "0" : "34.5%";
    var padding = activehanta ? "0" : "70px";
    var widthlink = activehanta ? "0" : "100%";
    var transform = activehanta ? "-100%" : "0";
    tl.to(document.querySelector(".desktop-menu__bottom .mega_menu .middle-menu"), {
      width: widthm,
      paddingLeft: padding,
      paddingRight: padding,
      opacity: '1',
      duration: 0.3,
      ease: 'power2.out',
      xPercent: transform
    }, '-=0.5').to('.desktop-menu__bottom .mega_menu .middle-menu li', {
      duration: 0.2,
      opacity: opacity,
      x: 0,
      stagger: 0.1,
      ease: 'power2.out'
    }, "-=0.4").to(document.querySelector(".desktop-menu__bottom .fixed_menu"), {
      width: width,
      duration: 0.5,
      ease: 'power2.out'
    }, "-=0.3");
    document.querySelector('body').classList.add('open_menu');
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(event) {};

    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  var removehidden = function removehidden(e) {
    setHoveredAttr('all'); // const mobile = document.querySelector("#mobile-subscribe");
    // mobile.classList.remove('visible')

    e.preventDefault();
  };

  var handleMouseEnter = function handleMouseEnter(attr) {
    setHoveredAttr(attr);
  };

  var headerRefMobile = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null); //---- on scroll menu fixed action

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var body = document.body;
    var scrollUp = "scroll-up";
    var scrollDown = "scroll-down";
    var lastScroll = 0;
    var howMuchScroll = 50;

    if (windowWidth > 776) {
      window.addEventListener("scroll", function () {
        var currentScroll = window.pageYOffset;

        if (currentScroll <= howMuchScroll) {
          body.classList.remove(scrollUp);
          return;
        }

        if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
          // down
          body.classList.remove(scrollUp);
          body.classList.add(scrollDown);
        } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
          // up
          body.classList.remove(scrollDown);
          body.classList.add(scrollUp);
        }

        lastScroll = currentScroll;
      });
    }

    if (document.body.classList.contains("scroll-down")) {
      document.body.classList.remove("scroll-down");
    }
  }, []); // news lett

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
  var responseData = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function (state) {
    return state.home;
  });

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_13__/* .useForm */ .cI)({
    mode: 'all'
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      formState = _useForm.formState,
      reset = _useForm.reset; //--- form submit


  var success = function success(msg) {
    return react_toastify__WEBPACK_IMPORTED_MODULE_4__/* .toast.success */ .Am.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var error = function error(msg) {
    return react_toastify__WEBPACK_IMPORTED_MODULE_4__/* .toast.error */ .Am.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var onSubmit = function onSubmit(e) {
    var api_services = _pages_api_network_ApiServices__WEBPACK_IMPORTED_MODULE_8__/* .ApiServices.ADDSUBSCRIP */ .u.ADDSUBSCRIP;
    var formData = new FormData();
    formData.append('email', e === null || e === void 0 ? void 0 : e.email);

    if (e.email !== '') {
      dispatch((0,_pages_api_redux_contact__WEBPACK_IMPORTED_MODULE_9__/* .postForm */ .Md)([_pages_api_network_ApiServices__WEBPACK_IMPORTED_MODULE_8__/* .ApiServices */ .u, formData]));
      success('Successfully Submitted');
      reset();
    }
  };

  var count = 0;

  var onError = function onError(errors) {
    Object.values(errors).forEach(function (error) {
      count++;
    });

    if (count > 0) {
      react_toastify__WEBPACK_IMPORTED_MODULE_4__/* .toast.error */ .Am.error('please fill with  correct inputs');
    }

    count = 0;
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.error) !== '') {
      error(responseData === null || responseData === void 0 ? void 0 : responseData.error);
    }

    if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.success) !== '') {// success(responseData?.success)
    }
  }, [responseData]); //

  var handleClick = function handleClick() {
    router.push('/'); // Navigate to the root route ('/')
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(StyledMobileMenu, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: "overlay ".concat(showSubmenu ? 'sub-menu-open ' : null)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      ref: headerRefMobile,
      className: "Mobile-menu-wrap menu-bar",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          className: "mobile-menu",
          ref: mobileMenuRaf,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            className: "logo forNormal",
            children: (location === null || location === void 0 ? void 0 : location.pathname) === "/" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
              children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                src: "/images/static/logo.svg",
                alt: 'Shanta Securities Limited'
              })]
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
              prefetch: true,
              onClick: handleClick,
              href: "/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
                children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                  src: "/images/static/logo.svg",
                  alt: 'Shanta Securities Limited'
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            className: "logo forClose",
            children: (location === null || location === void 0 ? void 0 : location.pathname) === "/" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
              children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                src: "/images/static/logo_dark.svg",
                alt: 'Shanta Securities Limited'
              })]
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
              prefetch: true,
              onClick: handleClick,
              href: "/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
                children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                  src: "/images/static/logo_dark.svg",
                  alt: 'Shanta Securities Limited'
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            className: "hamburger",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
              ref: hamburgerRef,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "32",
                height: "18",
                viewBox: "0 0 32 18",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                  id: "Hamburger_-_Light",
                  "data-name": "Hamburger - Light",
                  transform: "translate(1 1)",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                    id: "Line_3",
                    "data-name": "Line 3",
                    x2: "30",
                    fill: "none",
                    stroke: "#fff",
                    strokeLinecap: "round",
                    strokeWidth: "2"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                    id: "Line_4",
                    "data-name": "Line 4",
                    x2: "30",
                    transform: "translate(0 8)",
                    fill: "none",
                    stroke: "#fff",
                    strokeLinecap: "round",
                    strokeWidth: "2"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                    id: "Line_5",
                    "data-name": "Line 5",
                    x2: "30",
                    transform: "translate(0 16)",
                    fill: "none",
                    stroke: "#fff",
                    strokeLinecap: "round",
                    strokeWidth: "2"
                  })]
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
              ref: hamburgerCloseRef,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24.042",
                height: "24.042",
                viewBox: "0 0 24.042 24.042",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                  id: "Group_19860",
                  "data-name": "Group 19860",
                  transform: "translate(-337.373 -27.979)",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                    id: "Line_4",
                    "data-name": "Line 4",
                    x2: "30",
                    transform: "translate(338.787 29.393) rotate(45)",
                    fill: "none",
                    stroke: "#3c3c3b",
                    strokeLinecap: "round",
                    strokeWidth: "2"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                    id: "Line_4154",
                    "data-name": "Line 4154",
                    x2: "30",
                    transform: "translate(360 29.394) rotate(135)",
                    fill: "none",
                    stroke: "#3c3c3b",
                    strokeLinecap: "round",
                    strokeWidth: "2"
                  })]
                })
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
            className: "mobile-menu__items",
            ref: menuRef,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              className: "mobile-menu__items__top",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("ul", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
                    className: '',
                    href: "tel:+8801313778778",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "".concat(windowWidth),
                      height: "44",
                      viewBox: "0 0 ".concat(windowWidth, " 44"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                        id: "Group_19869",
                        "data-name": "Group 19869",
                        transform: "translate(-15 -998)",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                          id: "Rectangle_492",
                          "data-name": "Rectangle 492",
                          transform: "translate(15 998)",
                          fill: "none",
                          stroke: "#c6c6c6",
                          strokeWidth: "1",
                          opacity: "0.5",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                            width: "".concat(windowWidth),
                            height: "44",
                            rx: "22",
                            stroke: "none"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                            x: "0.5",
                            y: "0.5",
                            width: "".concat(windowWidth),
                            height: "43",
                            rx: "21.5",
                            fill: "none"
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                          id: "Rectangle_493",
                          "data-name": "Rectangle 492",
                          transform: "translate(15 998)",
                          fill: "none",
                          stroke: "#c6c6c6",
                          strokeWidth: "1",
                          opacity: "0",
                          strokeDasharray: "1 520",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                            width: "".concat(windowWidth),
                            height: "44",
                            rx: "22",
                            stroke: "none"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                            x: "0.5",
                            y: "0.5",
                            width: "".concat(windowWidth),
                            height: "43",
                            rx: "21.5",
                            fill: "none"
                          })]
                        })]
                      })
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("span", {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                        className: 'call_icon',
                        src: "/images/static/call_icon.svg",
                        alt: 'Shanta Securities Limited'
                      }), "01313778778"]
                    })]
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                  margin: '40px 0 40px',
                  padding: '0',
                  borderColor: 'transparent',
                  width: '100%',
                  border: 'none',
                  newtablink: 'https://portal.shantasecurities.com/signup',
                  target: '_blank',
                  text: 'Open an Account',
                  color: '#FFFFFF',
                  hoverBackground: '#3C3C3B',
                  background: '#978C21'
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                    prefetch: true,
                    href: "/search",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("svg", {
                        className: 'search_wrapper',
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "".concat(windowWidth),
                        height: "44",
                        viewBox: "0 0 ".concat(windowWidth, " 44"),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                          id: "Group_19869",
                          "data-name": "Group 19869",
                          transform: "translate(-15 -998)",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                            id: "Rectangle_492",
                            "data-name": "Rectangle 492",
                            transform: "translate(15 998)",
                            fill: "none",
                            stroke: "#c6c6c6",
                            strokeWidth: "1",
                            opacity: "0.5",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                              width: "".concat(windowWidth),
                              height: "44",
                              rx: "22",
                              stroke: "none"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                              x: "0.5",
                              y: "0.5",
                              width: "".concat(windowWidth),
                              height: "43",
                              rx: "21.5",
                              fill: "none"
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                            id: "Rectangle_493",
                            "data-name": "Rectangle 492",
                            transform: "translate(15 998)",
                            fill: "none",
                            stroke: "#c6c6c6",
                            strokeWidth: "1",
                            opacity: "0",
                            strokeDasharray: "1 520",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                              width: "".concat(windowWidth),
                              height: "44",
                              rx: "22",
                              stroke: "none"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                              x: "0.5",
                              y: "0.5",
                              width: "".concat(windowWidth),
                              height: "43",
                              rx: "21.5",
                              fill: "none"
                            })]
                          })]
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("span", {
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "20",
                          height: "20",
                          viewBox: "0 0 20 20",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("g", {
                            id: "search",
                            transform: "translate(-0.196)",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("path", {
                              id: "Path_8648",
                              "data-name": "Path 8648",
                              d: "M8.438,16.472A8.236,8.236,0,1,1,16.68,8.236a8.248,8.248,0,0,1-8.242,8.236Zm0-14.91a6.675,6.675,0,1,0,6.68,6.675,6.685,6.685,0,0,0-6.68-6.675Zm11.529,18.21a.78.78,0,0,0,0-1.1l-3.5-3.493a.781.781,0,1,0-1.1,1.1l3.5,3.493a.782.782,0,0,0,1.1,0Z",
                              transform: "translate(0 0)",
                              fill: "#3c3c3b"
                            })
                          })
                        }), "Search"]
                      })]
                    })
                  })
                })]
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("ul", {
              className: "mobile-menu__items__ul",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("li", {
                className: 'main_child',
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
                  href: "javascript:void(0)",
                  children: ["Shanta Securities Limited", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("svg", {
                    id: "Group_19302",
                    "data-name": "Group 19302",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                      id: "Rectangle_492",
                      "data-name": "Rectangle 492",
                      fill: "none",
                      stroke: "#3c3c3b",
                      strokeWidth: "1",
                      opacity: "0.5",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "12",
                        stroke: "none"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                        x: "0.5",
                        y: "0.5",
                        width: "23",
                        height: "23",
                        rx: "11.5",
                        fill: "none"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                      id: "Group_4824",
                      "data-name": "Group 4824",
                      transform: "translate(7 7)",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                        id: "Group_4823",
                        "data-name": "Group 4823",
                        transform: "translate(5)",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                          id: "Line_9",
                          "data-name": "Line 9",
                          y1: "5",
                          x2: "5",
                          transform: "translate(0 5)",
                          fill: "none",
                          stroke: "#3c3c3b",
                          strokeLinecap: "round",
                          strokeWidth: "1"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                          id: "Line_10",
                          "data-name": "Line 10",
                          x1: "5",
                          y1: "5",
                          fill: "none",
                          stroke: "#3c3c3b",
                          strokeLinecap: "round",
                          strokeWidth: "1"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                        id: "Line_11",
                        "data-name": "Line 11",
                        x2: "10",
                        transform: "translate(0 5)",
                        fill: "none",
                        stroke: "#3c3c3b",
                        strokeLinecap: "round",
                        strokeWidth: "1"
                      })]
                    })]
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("ul", {
                  className: 'submenu',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                    className: "main_title",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                        id: "Group_19302",
                        "data-name": "Group 19302",
                        transform: "translate(24 24) rotate(180)",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                          id: "Rectangle_492",
                          "data-name": "Rectangle 492",
                          fill: "none",
                          stroke: "#3c3c3b",
                          strokeWidth: "1",
                          opacity: "0.5",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                            width: "24",
                            height: "24",
                            rx: "12",
                            stroke: "none"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                            x: "0.5",
                            y: "0.5",
                            width: "23",
                            height: "23",
                            rx: "11.5",
                            fill: "none"
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                          id: "Group_4824",
                          "data-name": "Group 4824",
                          transform: "translate(7 7)",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                            id: "Group_4823",
                            "data-name": "Group 4823",
                            transform: "translate(5)",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                              id: "Line_9",
                              "data-name": "Line 9",
                              y1: "5",
                              x2: "5",
                              transform: "translate(0 5)",
                              fill: "none",
                              stroke: "#3c3c3b",
                              strokeLinecap: "round",
                              strokeWidth: "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                              id: "Line_10",
                              "data-name": "Line 10",
                              x1: "5",
                              y1: "5",
                              fill: "none",
                              stroke: "#3c3c3b",
                              strokeLinecap: "round",
                              strokeWidth: "1"
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                            id: "Line_11",
                            "data-name": "Line 11",
                            x2: "10",
                            transform: "translate(0 5)",
                            fill: "none",
                            stroke: "#3c3c3b",
                            strokeLinecap: "round",
                            strokeWidth: "1"
                          })]
                        })]
                      })
                    }), "Shanta Securities Limited"]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                      prefetch: true,
                      href: "/about",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                        children: "Who We Are"
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                      prefetch: true,
                      href: "/about#mission-vision",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                        children: "Our Mission and Vision "
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                      prefetch: true,
                      href: "/about#core-values",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                        children: "Our Core Values "
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                      prefetch: true,
                      href: "/about#our-board",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                        children: "Our Board "
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                      prefetch: true,
                      href: "/about#our-team",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                        children: "Our Team"
                      })
                    })
                  })]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                  prefetch: true,
                  href: "/our-services",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    children: "Our Services"
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                  prefetch: true,
                  href: "/research",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    children: "Research Center"
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                  prefetch: true,
                  href: "/investment-calculator",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    children: " Investment Calculator "
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                  prefetch: true,
                  href: "/career",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    children: "Career"
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                  prefetch: true,
                  href: "/news",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    children: "News"
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                  prefetch: true,
                  href: "/contact",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    children: "Contacts"
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                  prefetch: true,
                  href: "/downloads",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    children: " Downloads"
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                  prefetch: true,
                  href: "/campaign",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    children: "Campaign"
                  })
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
              className: "mobile-menu__items__bottom",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: "",
                onClick: function onClick() {
                  return handleMouseEnter('mobile-news');
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                  border: '0',
                  margin: '40px 0 0',
                  padding: '0',
                  borderColor: 'transparent',
                  width: '100%',
                  text: 'Subscribe to Newsletter',
                  color: '#FFFFFF',
                  hoverBackground: _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_17__/* .hover */ .Mr,
                  background: '#C6C6C6'
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("ul", {
                "data-tab": 'mobile-news',
                id: 'mobile-subscribe',
                className: "submenu ".concat(hoveredAttr === 'mobile-news' ? 'visible' : 'hidden'),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                  onClick: function onClick() {
                    return removehidden();
                  },
                  className: "main_title",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                      id: "Group_19302",
                      "data-name": "Group 19302",
                      transform: "translate(24 24) rotate(180)",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                        id: "Rectangle_492",
                        "data-name": "Rectangle 492",
                        fill: "none",
                        stroke: "#3c3c3b",
                        strokeWidth: "1",
                        opacity: "0.5",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                          width: "24",
                          height: "24",
                          rx: "12",
                          stroke: "none"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("rect", {
                          x: "0.5",
                          y: "0.5",
                          width: "23",
                          height: "23",
                          rx: "11.5",
                          fill: "none"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                        id: "Group_4824",
                        "data-name": "Group 4824",
                        transform: "translate(7 7)",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("g", {
                          id: "Group_4823",
                          "data-name": "Group 4823",
                          transform: "translate(5)",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                            id: "Line_9",
                            "data-name": "Line 9",
                            y1: "5",
                            x2: "5",
                            transform: "translate(0 5)",
                            fill: "none",
                            stroke: "#3c3c3b",
                            strokeLinecap: "round",
                            strokeWidth: "1"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                            id: "Line_10",
                            "data-name": "Line 10",
                            x1: "5",
                            y1: "5",
                            fill: "none",
                            stroke: "#3c3c3b",
                            strokeLinecap: "round",
                            strokeWidth: "1"
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("line", {
                          id: "Line_11",
                          "data-name": "Line 11",
                          x2: "10",
                          transform: "translate(0 5)",
                          fill: "none",
                          stroke: "#3c3c3b",
                          strokeLinecap: "round",
                          strokeWidth: "1"
                        })]
                      })]
                    })
                  }), "Subscribe to Newsletter"]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                  className: "form-content",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    margin: '0 0 40px 0',
                    text: 'Want updates on the go? </br> Sign up for Daily Newsflash</br> and never miss a thing!'
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    className: "",
                    onSubmit: '',
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Group */ .Z.Group, {
                      className: "form-group",
                      controlId: "formBasicEmail",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Control */ .Z.Control, {
                        autocomplete: "off",
                        name: "email",
                        type: "email",
                        placeholder: "Your Email Address"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                        className: "dc-btn-submit",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                          width: '100',
                          text: 'Subscribe',
                          color: '#FFFFFF',
                          hoverBackground: '#3C3C3B',
                          background: '#978C21'
                        })
                      })]
                    })
                  })]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                border: 'none',
                src: 'easytrade',
                margin: '20px 0 0',
                padding: '0',
                icon: true,
                width: '100%',
                text: 'Shanta EasyTrade',
                color: '#FFFFFF',
                hoverBackground: '#3C3C3B',
                background: '#978C21'
              })]
            })]
          })]
        })
      })
    })]
  });
};

var StyledMobileMenu = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "MainMenuMobile__StyledMobileMenu",
  componentId: "sc-eqr67r-0"
})(["position:fixed;top:0;left:0;width:100%;height:80px;z-index:99999;display:flex;align-items:center;transition:background .4s cubic-bezier(0.4,0,0,1);overflow:visible !important;background:rgba(0,0,0,0.3);box-shadow:0 0 20px rgba(0,0,0,0.20);.Mobile-menu-wrap{width:100% !important;height:80px;align-items:center;display:flex;}.call_icon{height:20px;}.forClose{display:none !important;a{img{height:40px !important;}}}&.menu-open{background:rgba(255,255,255,1) !important;.forNormal{display:none !important;}.forClose{display:block !important;}}.mobile-menu{.logo{display:flex;align-items:center;padding:0 15px;span{width:220px !important;}a{display:flex;svg,img{height:40px;width:200px;}}}.hamburger{position:relative;display:flex;align-items:center;span{position:absolute !important;right:15px !important;display:flex;p{font-size:16px;font-weight:400;line-height:20px;color:#F9F9F9;margin:0 10px 0 0;}&:nth-of-type(2){display:none !important;}}&.menu-open span{&:nth-of-type(1){display:none !important;}&:nth-of-type(2){display:flex !important;right:20px !important;}}}&__items{display:none;position:absolute;opacity:0;background-color:#F8F8F8;height:calc(100vh - 80px);top:80px;left:0;width:100%;z-index:99;padding:60px 15px 120px 15px;overflow:auto;transition:opacity .5s cubic-bezier(0.4,0,0,1);overflow-y:scroll;&:after{position:absolute;left:0;right:0;top:0;background:#C4C4C4;height:1px;margin:0 auto;width:calc(100% - 30px);}&__top{ul{li{&:first-child{a{justify-content:center;}svg{width:100%;#_16634{fill:#3C3C3B;}#Rectangle_493{transition:1s all ease}width:100%;position:absolute;left:0;right:0;@media(max-width:767px){border:1px solid #3C3C3B;border-radius:30px;}}&:hover{span{color:rgb(60,60,59);}svg{#Rectangle_493{opacity:1;stroke-dasharray:520px;}}}}&:last-child{a{justify-content:center;}@media(max-width:767px){.search_wrapper{border:1px solid #3C3C3B;border-radius:30px;}}svg{width:100%;#_16634{fill:#3C3C3B;}#Rectangle_493{transition:1s all ease}width:100%;position:absolute;left:0;right:0;}&:hover{span{color:rgb(60,60,59);}svg{#Rectangle_493{opacity:1;stroke-dasharray:520px;}}}}a{width:100%;display:flex;align-items:center;justify-content:flex-start;position:relative;margin-bottom:30px;img{margin-right:10px;}span{display:flex;}}&:nth-last-child(1) a{a{justify-content:center;}svg{width:100%;#_16634{fill:#3C3C3B;}#Rectangle_493{transition:1s all ease}width:100%;position:absolute;left:0;right:0;}span{svg{display:flex;position:unset;margin-right:8px;}}&:hover{span{color:rgb(60,60,59);}svg{#Rectangle_493{opacity:1;stroke-dasharray:520px;}}}}}}margin-bottom:80px;}&__bottom{.submenu{padding:60px 15px 30px;position:fixed;right:0;top:80px;left:0;bottom:0;background:#F8F8F8;width:100%;opacity:0;visibility:hidden;transition:0.7s all cubic-bezier(0.4,0,0,1);transform:translateX(100%);overflow-x:scroll;z-index:9;&::-webkit-scrollbar{display:none;}.main_title{text-align:left;display:flex;color:#3C3C3B;margin-bottom:60px;font-weight:500;font-size:20px;line-height:28px;svg{margin-right:20px;position:relative;z-index:-1;}}padding-bottom:18px;border-bottom:1px solid rgba(225,228,230,0.5) !important;margin-bottom:18px;&:last-child{margin-bottom:0;border-bottom:none !important;}.form-group{position:relative;.form-control{height:45px;background-color:transparent;border-radius:40px;font-size:16px;font-weight:500;padding-left:30px;color:#3C3C3B;autocomplete:off;border-color:rgba(60,60,59,0.5);::placeholder{color:rgba(60,60,59,0.5);font-size:16px;font-weight:500;outline:none;border:none;}:focus{outline:none;outline-color:#3C3C3B;border-color:#3C3C3B;}}.dc-btn-submit{position:absolute;top:0;right:0;.dc-btn{height:45px;}a{display:flex;height:100%;width:100%;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;font-size:16px;font-weight:500;margin:0px;line-height:18px;color:#3C3C3B;text-transform:capitalize;border:none;letter-spacing:0px;position:relative;border-radius:30px;overflow:hidden;span{}}}}a{color:#3C3C3B;font-weight:500;font-size:20px;line-height:28px;}&.visible{opacity:1;visibility:visible;transform:translateX(0);}&.hidden{opacity:0;visibility:hidden;transform:translateX(100%);}}}&__ul{li{padding-bottom:18px;border-bottom:1px solid rgba(225,228,230,0.5) !important;margin-bottom:18px;&:last-child{margin-bottom:0;border-bottom:none !important;}a{color:#3C3C3B;font-weight:500;font-size:20px;line-height:28px;}}}}&.menu-open{.mobile-menu__items{display:block;}}.main-child-sub{a{display:flex;justify-content:space-between;}}.main_child{a{width:100%;padding:0;box-shadow:none;display:flex;justify-content:space-between;@media (max-width:767px){img{z-index:-1;position:relative;}}p{margin:0;font-size:22px;line-height:28px;text-transform:capitalize;font-weight:bold;padding-right:30px;width:100%;}span{&:nth-last-child(2){display:none !important;}&:nth-last-child(1){display:block !important;}}&.collapsed{span{&:nth-last-child(2){display:block !important;}&:nth-last-child(1){display:none !important;}}}&.collapsed{border-bottom:1px solid #E1E4E6;}}&.submenu-open-mb{.submenu{opacity:1;visibility:visible;transform:translateX(0);}.submenu-open-next{.mega_sub{opacity:1;visibility:visible;transform:translateX(0);}}.submenu-open-next-next{.mega_sub_sub{opacity:1;visibility:visible;transform:translateX(0);}}}.submenu{padding:60px 15px 30px;position:fixed;right:0;top:80px;left:0;bottom:0;background:#F8F8F8;width:100%;opacity:0;visibility:hidden;transition:0.7s all cubic-bezier(0.4,0,0,1);transform:translateX(100%);overflow-x:scroll;z-index:9;&::-webkit-scrollbar{display:none;}.main_title{text-align:left;display:flex;color:#3C3C3B;margin-bottom:60px;font-weight:500;font-size:20px;line-height:28px;svg{margin-right:20px;position:relative;z-index:-1;}}padding-bottom:18px;border-bottom:1px solid rgba(225,228,230,0.5) !important;margin-bottom:18px;&:last-child{margin-bottom:0;border-bottom:none !important;}a{color:#3C3C3B;font-weight:500;font-size:20px;line-height:28px;}}.fotter_menu{margin-top:150px;h3{font-size:32px;color:#4F616B;line-height:32px;}p{font-size:14px;font-weight:400;line-height:20px;color:#4F616B;}.footer{margin-top:40px;a{font-size:24px;font-weight:400;line-height:28px;color:#4F616B;padding:0;display:block;margin:0 0 10px;border:none;&:last-child{margin:0;}}}}&:nth-last-child(1){.accordion-button{}}}}@media (min-width:993px){display:none;}"]);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(MainMenu));

/***/ }),

/***/ 93264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68777);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68312);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var Title = function Title(_ref) {
  var text = _ref.text,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      color = _ref.color,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      textTransform = _ref.textTransform,
      margin = _ref.margin,
      padding = _ref.padding,
      borderColor = _ref.borderColor,
      varient = _ref.varient,
      center = _ref.center,
      classname = _ref.classname,
      small_text = _ref.small_text,
      noanim = _ref.noanim,
      h1 = _ref.h1;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledTitle, {
    className: "title fade-up ".concat(classname),
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    lineHeight: lineHeight,
    LetterSpacing: letterSpacing,
    textTransform: textTransform,
    margin: margin,
    padding: padding,
    varient: varient,
    center: center,
    borderColor: borderColor,
    children: text ? h1 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("h1", {
      className: "".concat(noanim ? '' : 'split-up'),
      children: [" ", (0,react_html_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(text), " "]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("h2", {
      className: "".concat(noanim ? '' : 'split-up'),
      children: [" ", (0,react_html_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(text), " "]
    }) : ''
  });
};

var StyledTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Title__StyledTitle",
  componentId: "sc-n2utlk-0"
})(["margin:", ";position:relative;width:100%;font-family:", ";text-align:", ";padding:", ";h2{font-family:", ";font-size:", "px;line-height:", "px;letter-spacing:-1px;font-weight:", ";color:", ";span{color:", ";}}h1{font-family:", ";font-size:", "px !important;line-height:", "px !important;letter-spacing:-1px !important;font-weight:", " !important;color:", " !important;span{color:", " !important;}}@media (max-width:767px){margin-bottom:40px;padding:0;h2{font-size:35px !important;line-height:42px !important;sub{bottom:9.1px;line-height:inherit;}}h1{font-size:35px !important;line-height:42px !important;sub{bottom:9.1px;line-height:inherit;}}}"], function (props) {
  return props.margin || '0px';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .title */ .TN, function (props) {
  return props !== null && props !== void 0 && props.center ? 'center' : '';
}, function (p) {
  return p.padding;
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .title */ .TN, function (props) {
  return props.fontSize || 44;
}, function (props) {
  return props.lineHeight || 56;
}, function (props) {
  return props.fontWeight || '500';
}, function (props) {
  return props.color || '#3C3C3B';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .title */ .TN, function (props) {
  return props.fontSize || 44;
}, function (props) {
  return props.lineHeight || 56;
}, function (props) {
  return props.fontWeight || '500';
}, function (props) {
  return props.color || '#3C3C3B';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Title));

/***/ }),

/***/ 92495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ ApiServices; }
/* harmony export */ });
var ApiServices = {
  POSTS: 'get-req-data/posts',
  PHOTOS: 'get-req-data/photos',
  PAGE_DATA: 'get-req-data/page-data',
  SECTIONS: 'get-req-data/sections',
  SERVICERESEARCH: 'get-req-data/research-documents-all',
  JOB: 'get-req-data/job-list',
  TEAM: 'get-req-data/team-list',
  CHILD_PAGE: 'get-req-data/child-pages',
  PAGE_POST_DATA: 'get-req-data/page-post-data',
  SEARCH: 'get-req-data/search',
  SEARCHCAMPAIGN: 'get-req-data/campaign-search',
  ALL_CATEGORY: 'get-req-data/all-category',
  CHILD_CATEGORY: 'get-req-data/child-category',
  PRODUCT_DATA: 'get-req-data/product-data',
  ALL_PRODUCTS: 'get-req-data/all-products',
  POST_FORM: 'post-req-data/form-submit',
  // POST_FORM: 'form-fields?form_id=contact-form',
  // SERVICE_FORM: 'get-req-data/form-fields?form_id=our-services-form',
  SERVICE_FORM: 'post-req-data/form-submit',
  // GETINTOUCH_FORM: 'get-req-data/form-fields?form_id=get-in-touch',
  GETINTOUCH_FORM: 'post-req-data/form-submit',
  FIND_DEALER: 'get-req-data/dealer-location',
  // GOOGLE_PLACE_NEARBY:"place/nearbysearch/json"
  SETTINGS: 'get-req-data/settings-data',
  COURSEDATA: 'get-req-data/course-data',
  BlogData: 'get-req-data/blog-data',
  RESEARCHLIST: 'get-req-data/research-list',
  ADDSUBSCRIP: 'post-req-data/add-subscriber',
  SUBMITFORM: 'post-req-data/form-submit',
  INVESTOR: 'get-req-data/investor-data',
  REARCHLISTCAT: 'get-req-data/research-documents',
  BLOGCATEGORY: 'get-req-data/blog-list?category_id=21',
  HOMEJSON: 'json-data/home'
};

/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ })

}]);